/**
 * ComicViewerSection
 * Sección de visualización del cómic
 */
import React, { memo } from "react";
import { motion } from "framer-motion";
import ComicViewer from "./ComicViewer";
import CloseButton from "../../shared/components/CloseButton";

const ComicViewerSection = ({ currentSection, comicImages }) => {
    return (
        <motion.div
            key={`${currentSection}-comic`}
            className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-90"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            style={{ overflow: "hidden" }}
        >
            <CloseButton />
            <ComicViewer comicImages={comicImages} />
        </motion.div>
    );
};

export default memo(ComicViewerSection);
